import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image1 from "../../../Img/Proyectos/ProyectosResidenciales/Palmas14/61ce062d8d36f1ba32b8fa15_1.jpg"
import image2 from "../../../Img/Proyectos/ProyectosResidenciales/Palmas14/61ce0668856e75269c3e79f9_338-3887_IMG.jpg"
import image3 from "../../../Img/Proyectos/ProyectosResidenciales/Palmas14/61ce06688bd4f5afc279e1de_337-3709_IMG_2.jpg"
import image4 from "../../../Img/Proyectos/ProyectosResidenciales/Palmas14/61ce066a3bb7541c7d85693d_336-3708_IMG_2.jpg"
import image5 from "../../../Img/Proyectos/ProyectosResidenciales/Palmas14/61ce066a64d1626c880e3aec_337-3701_IMG_2.jpg"
import image6 from "../../../Img/Proyectos/ProyectosResidenciales/Palmas14/61ce066ed2268b200f6c40da_339-3936_IMG_2.jpg"

function ProyectoPalmas14() {

    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Residencial - Plamas 14</title>
            </Helmet>

            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5, image6
                ]}

                slide={lightboxController.slide}
            />

            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-residenciales">Residenciales</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Casa Palmas 14</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Casa Palmas 14</h1>
                <h6 className="py-2 m-0 p-0">Guadalajara, Jal. <h6>2002</h6></h6>
            </div>

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(6)}
                            src={image6}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                </div>
            </div>
        </>
    );
}

export default ProyectoPalmas14;
